import {remCalc} from '_themeUtils'

const NewsletterModalStep1 = {
    NewsletterModal_step_1: {
        baseStyle: () => ({
            form: {
                h: '100%',
                opacity: '1',
                transition: 'opacity 0.2s ease-in-out',
            },
            titleWrapper: {
                mt: 'spacing.4',
                textStyle: {base: 'displayXs', md: 'displaySm'},
                fontWeight: 400,
            },
            descriptionWrapper: {
                textStyle: 'paragraphSm',
                color: 'color.text.grey.700',
                fontWeight: 400,
                mb: 'spacing.none',
                mt: 'spacing.none',
            },
            mandatoryFieldsWrapper: {
                textStyle: 'paragraphXs',
                color: 'color.text.grey.500',
                fontWeight: 400,
                mb: 'spacing.none',
                mt: 'spacing.none',
            },
            inputWrapper: {
                mt: 'spacing.8',
            },
            footerWrapper: {
                p: {base: `${remCalc(24)} ${remCalc(16)} ${remCalc(40)}`, md: `${remCalc(24)} ${remCalc(24)} ${remCalc(40)} ${remCalc(56)}`},
                m: {base: `auto -${remCalc(16)} 0 -${remCalc(16)}`, md: `auto -${remCalc(24)} 0 -${remCalc(56)}`},
                position: 'sticky',
                bottom: '0',
                zIndex: '1',
                flexDirection: 'column',
                bg: '#f9f9f9',
            },
            button: {
                alignSelf: 'center',
                w: '100%',
                textTransform: 'uppercase',
                letterSpacing: remCalc(3),
                h: remCalc(54),
            },
            footerCopyrightMessage: {
                textStyle: 'paragraphXs',
                pt: remCalc(16),
                pb: 'spacing.4',
                color: 'color.text.grey.700',
                fontWeight: 400,
                sx: {
                    '.cc-privacy-link': {
                        textStyle: 'paragraphXs',
                        textDecoration: 'underline',
                        lineHeight: remCalc(1),
                        _hover: {
                            color: 'color.text.black',
                            textDecoration: 'underline',
                        },
                    },
                },
            },
            recaptchaMessage: {
                textStyle: 'paragraphXs',
                display: 'inline',
                textAlign: 'left',
                color: 'color.text.grey.700',
                fontWeight: 400,
                sx: {
                    'a, a:hover': {
                        textDecoration: 'underline',
                    },
                },
            },
            errorMessageWrapper: {
                color: 'color.text.error',
                textStyle: 'paragraphXs',
                lineHeight: remCalc(20),
                fontWeight: 400,
                letterSpacing: remCalc(0.5),
                pl: 'spacing.3',
                sx: {
                    Button: {
                        color: 'color.text.error',
                        textStyle: 'paragraphXs',
                        lineHeight: remCalc(20),
                        fontWeight: 400,
                        letterSpacing: remCalc(1),
                        textTransform: 'none',
                        p: 'spacing.none',
                        pb: remCalc(2),
                        borderColor: 'color.border.black',
                    },
                },
            },
        }),
    },
}

export default NewsletterModalStep1
